import { useContext } from 'react'
import VehicleEnquiryContext from '../context/VehicleEnquiryProvider';


const useVehicleEnquiry = () => {
    return useContext(VehicleEnquiryContext);
}

export default useVehicleEnquiry